import dayjs from "dayjs";

export function relativeTime(ts: number): string {
  const diff = Date.now() - ts;
  const m = Math.floor(diff / 60_000);
  if (m < 1) return "just now";
  if (m < 60) return `${m}m`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h`;
  const d = Math.floor(h / 24);
  return `${d}d`;
}

// A time that is usually ahead (a scheduled run): "in 4m", or how overdue it is.
export function untilIso(iso: string | null | undefined): string {
  if (!iso) return "not scheduled";
  const diff = new Date(iso).getTime() - Date.now();
  const span = (ms: number) =>
    ms < 60_000 ? `${Math.max(1, Math.round(ms / 1000))}s` : ms < 3_600_000 ? `${Math.floor(ms / 60_000)}m` : `${Math.floor(ms / 3_600_000)}h`;
  return diff >= 0 ? `in ${span(diff)}` : `overdue ${span(-diff)}`;
}

export function relativeIso(iso: string | null | undefined): string {
  if (!iso) return "never";
  const diff = Date.now() - new Date(iso).getTime();
  if (diff < 60_000) return "just now";
  if (diff < 3_600_000) return `${Math.floor(diff / 60_000)}m ago`;
  if (diff < 86_400_000) return `${Math.floor(diff / 3_600_000)}h ago`;
  return `${Math.floor(diff / 86_400_000)}d ago`;
}

export function formatMoney(amount: number, currency = "USD"): string {
  const fractionDigits =
    amount === 0 ? 2 : amount < 0.01 ? 4 : amount < 1 ? 3 : 2;
  return new Intl.NumberFormat(undefined, {
    style: "currency",
    currency,
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  }).format(amount);
}

export function formatCost(amount: number, currency = "USD"): string {
  if (amount === 0) {
    return new Intl.NumberFormat(undefined, {
      style: "currency",
      currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(0);
  }
  return formatMoney(amount, currency);
}

export function formatCostLong(amount: number, currency = "USD"): string {
  return formatMoney(amount, currency);
}

export function formatTokens(n: number): string {
  if (n < 1000) return String(n);
  if (n < 1_000_000) return `${(n / 1000).toFixed(1)}k`;
  return `${(n / 1_000_000).toFixed(1)}M`;
}

export function formatMonthYear(iso: string): string {
  return dayjs(iso).format("MMM YYYY");
}

export function formatDate(iso: string | Date): string {
  return dayjs(iso).format("MMM D, YYYY");
}
